/**
 * `usePageTitle` (TMMAPP-0072, TMM-B7) — the one call a page makes for its title. It feeds the
 * app bar (`useHeader`, shown below `md`) and `document.title` (`useDocumentTitle`), and returns
 * the title the page hands to its `PageHeader`, so the three never drift apart.
 *
 * A title that depends on data (a virtual account's name) is `null` until it loads: the bar and the
 * tab show the catalog `fallback` meanwhile (never blank), and `PageHeader` shows its title
 * skeleton.
 */
import { useDocumentTitle } from '@/shared/useDocumentTitle';
import { useHeader } from './headerContext';

export type PageTitleInput =
  { title: string; fallback?: undefined } | { title: string | null; fallback: string };

export function usePageTitle({ title, fallback }: PageTitleInput): string | null {
  const shown = title ?? fallback ?? '';
  useHeader({ title: shown === '' ? null : shown });
  useDocumentTitle(shown === '' ? null : shown);
  return title;
}
